export const calculateTimeDifference = (targetDate, currentDate) => {
  const diffInMs = currentDate - targetDate;

  const diffInMinutes = Math.floor(diffInMs / 1000 / 60);

  const remainingMinutes = diffInMinutes % 60;

  return { remainingMinutes };
};
